// @ts-nocheck

export type OwnerGetWithOperationRulesOperationRuleLogs = typeof OwnerGetWithOperationRulesOperationRuleLogs[keyof typeof OwnerGetWithOperationRulesOperationRuleLogs];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OwnerGetWithOperationRulesOperationRuleLogs = {
  true: 'true',
  false: 'false',
} as const;
